function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

$(document).ready(function(){
	
	$('form.contact_form input').focus(function(){
		$(this).removeClass('error-warning');
		$(this).parent().removeClass('error-warning');
	});
	
	$('form.contact_form').submit(function(evt){
		
		var error = false; 
		var country = $(this).data('country');
		
		$(this).find('input[type=text].validate, input[type=email].validate').each(function(){
			if( $(this).val().trim().length <= 0 ) {
				$(this).addClass('error-warning');
				error = true;
			}
		});
		
		$(this).find('input[type=checkbox].validate').each(function(){
			if( !$(this).prop('checked') ) {
				$(this).parent().addClass('error-warning');
				error = true;
			}
		});
		
		$(this).find('.email').each(function(){
			if( !validateEmail( $(this).val() )) {
				$(this).addClass('error-warning');
				error = true;
			}
		});
		
		$(this).find('.numbers').each(function(){
			
			if( !$(this).val().match(/^[0-9]+$/) ) {
				$(this).addClass('error-warning');
				error = true;
			}
		});
		
		// Country specific rules
		
		switch(country) {
			case 'fr':
			
				var input = $(this).find('input[name="postal"]');
				var postal = input.val();
				
				console.log(postal.trim(), postal.trim().length < 5 || !postal.trim().match(/^[0-9]+$/));
				
				if(postal.trim().length < 5 || !postal.trim().match(/^[0-9]+$/)) {
					input.addClass('error-warning');
					error = true;
				}
			
				break;
		}
		
		var form = $(this);
		
		if( !error ) {
			
			$('body').addClass('loading').append('<section class="modal" ><div class="loader"></div></section>');
			return true;
		}
		
		return false;
	});
	
	if( $('.modal.thanks').length > 0 ) {
		setTimeout(function(){
			$('.modal.thanks').fadeOut( function(){
				$(this).remove();	
			});
		}, 3000);
	}
	
});